import { getApplicationKeepAliveApi } from "../api/idleSession";


export const keepAlive = async () => {
    try {
      const response = await getApplicationKeepAliveApi();
      if (!response) {
        throw new Error("Invalid response structure");
      }
      return response;
    } catch (error: any) {
      console.error("Unexpected error in keepAlive:", error.message);
      return null;
    }
  }